import {useReports} from '@sail/observability';
import {once} from '@sail/utils';
import {createContext, useContext} from 'react';

import type {Errors} from '@sail/observability';
import type {UiConfig} from 'src/types';

class UiConfigError extends Error {
  constructor(message: string) {
    super(`[@sail/stripelet] ${message}`);
  }
}

export const uninitializedUiConfigError = () =>
  new UiConfigError(
    'Make sure to provide the required config for ui to UiProvider upon initialization.',
  );

const reportUninitializedErrorOnce = once((reportError: Errors['error']) => {
  reportError(uninitializedUiConfigError(), {
    tags: {namespace: 'ui'},
  });
});

export const UiConfigContext = createContext<UiConfig | undefined>(undefined);

export function useUiConfig(): UiConfig {
  const config = useContext(UiConfigContext);
  const {error} = useReports();

  if (!config) {
    reportUninitializedErrorOnce(error);

    throw uninitializedUiConfigError();
  }

  return config;
}
